import React, { useEffect, useState } from 'react'
import { GetAllFAQ } from '../services/website.services';
import Skeleton from 'react-loading-skeleton';
import RecordNotFound from '../shared/RecordNotFound';
import { Link } from 'react-router-dom';

function Faq() {
  const [faqData, setFaqData] = useState([]);
  const [apiLoaded, setApiLoaded] = useState(false);

  useEffect(() => {
    GetAllFAQ()
      .then((response) => {
        setApiLoaded(true);
        setFaqData(response?.data?.list);
      })
      .catch((error) => {
        console.log("Error===>", error)
      })
  }, []);

  return (
    <>
      {apiLoaded ?
        faqData?.length ?
          <div className='faq-pages'>
            <div className="heading-banner-page">
              <div className="container">
                <h1>Frequently Asked Questions</h1>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Frequently Asked Questions</li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className='innerpage-padding'>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="card faq-content">
                      <div className="card-body">
                        <div className="accordion accordion-flush" id="accordionFlushExample">
                          {faqData?.map((data, index) => (
                            <div key={index} className="accordion-item">
                              <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse${index}`} aria-expanded="false" aria-controls={`flush-collapse${index}`}>
                                  {data?.title}
                                </button>
                              </h2>
                              <div id={`flush-collapse${index}`} className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                <div className="accordion-body" dangerouslySetInnerHTML={{ __html: data?.description }}></div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          : <RecordNotFound heading='website.faq.web_faq_record_not_found_heading' />
        :
        // <section className="section-padding">
        //   <div className="row">
        //     <div className="col-lg-3 col-md-4 ">
        //       <Skeleton className='rounded-4' height={200} />
        //     </div>
        //     <div className="col-lg-3 col-md-4  d-none d-md-block">
        //       <Skeleton className='rounded-4' height={200} />
        //     </div>
        //     <div className="col-lg-3 col-md-4  d-none d-md-block">
        //       <Skeleton className='rounded-4' height={200} />
        //     </div>
        //     <div className="col-lg-3 col-md-4  d-none d-lg-block">
        //       <Skeleton className='rounded-4' height={200} />
        //     </div>
        //   </div>
        // </section>
        <section className="section-padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card m-5">
                  <div className="card-body">
                    <Skeleton className='rounded-1' height={50} count={3} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </>
  )
}

export default Faq
